import React from 'react';
import {
  Transcript, WhatsNew, Eye, Label, Text, BookmarkIcon,
} from '@picsio/icons';

const rotatedStyle = { transform: 'rotate(180deg)' };

export default [
  {
    value: 'summary',
    text: 'AI Summary',
    icon: <Transcript style={rotatedStyle} />,
    amplitudeEventName: 'VideoIntelligenceAISummarySelected',
  },
  {
    value: 'transcript',
    text: 'Transcript',
    icon: <Transcript />,
    amplitudeEventName: 'VideoIntelligenceTranscriptSelected',
  },
  {
    value: 'actions',
    text: 'Actions',
    icon: <WhatsNew />,
    amplitudeEventName: 'VideoIntelligenceActionsSelected',
  },
  {
    value: 'chapters',
    text: 'Chapters',
    icon: <BookmarkIcon />,
    amplitudeEventName: 'VideoIntelligenceChaptersSelected',
  },
  {
    value: 'ocr',
    text: 'Recognized text (OCR)',
    icon: <Text />,
    amplitudeEventName: 'VideoIntelligenceOCRSelected',
  },
  {
    value: 'keywords',
    text: 'Keywords',
    icon: <Label />,
    amplitudeEventName: 'VideoIntelligenceKeywordsSelected',
  },
  {
    value: 'separator',
    text: '',
    icon: null,
  },
  {
    value: 'reader-mode',
    text: 'Transcript reader view',
    icon: <Eye />,
    amplitudeEventName: 'TranscriptReaderModeOn',
  },
];
